import { useState } from "react";
import { Frame, Node, Flow, Detail } from "@/components/diagrams/kit";

const STAGES = [
  { name: "Plant 1 → Line 3", tone: "neutral", d: "Frame the request: asset (Line 3), metric (OEE), timeframe (last three shifts), output (ranked investigation for the next shift)." },
  { name: "Governed evidence", tone: "data", d: "Historian via connector, work orders via CMMS tool, SOPs via RAG, relationships via the asset graph — each checked for permissions, units, timestamps and quality flags." },
  { name: "Context pack", tone: "action", d: "Per-machine aggregates for three shifts, flagged stale torque tag, inconsistent LBL_03_Spd name, cited SOP excerpt — plus an output reserve." },
  { name: "Handover + pilot brief", tone: "trust", d: "Evidence-backed answer with unknowns, a handover-ready next step, and a one-line pilot brief with owner and measures." },
];

export default function CapstoneFlow() {
  const [sel, setSel] = useState(0);
  return (
    <Frame title="Capstone: Line 3 OEE decline" hint="Step through the investigation" testId="diagram-capstone-flow">
      <div className="flex flex-col sm:flex-row">
        {STAGES.map((s, i) => (
          <div key={s.name} className="flex flex-col sm:flex-1 sm:flex-row">
            <Node testId={`capflow-${i}`} tone={s.tone} active={sel === i} dim={i > sel} onClick={() => setSel(i)}>
              <div className="font-mono text-[10px] opacity-70">Step {i + 1}</div><div className="font-semibold">{s.name}</div>
            </Node>
            {i < STAGES.length - 1 && <Flow on={i < sel} />}
          </div>
        ))}
      </div>
      <Detail testId="capflow-detail"><span key={sel}>{STAGES[sel].d}</span></Detail>
    </Frame>
  );
}
